import { AnchorHTMLAttributes, FC } from "react";
import styled from "styled-components";

const TwitterButton: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ children, ...props }) => {
  return (
    <Root {...props}>
      <TwitterIcon src="https://animefund.com/img/sns/twitter_logo.svg" />
      <Text>{children}</Text>
    </Root>
  );
};
export default TwitterButton;

const Root = styled.a`
  font-size: 1.2em;
  padding: 0.6em 1em;
  color: white;
  background-color: #1da1f1;
  display: flex;
  align-items: center;
  letter-spacing: 0;
  border-radius: 14px;
`;
const TwitterIcon = styled.img`
  width: 1em;
  height: 1em;
  margin-right: 0.6em;
`;
const Text = styled.span`
  color: white;
`;
